import React from 'react'
import format from '@st-operations/uikit/lib/format'
import { Icon } from '@st-operations/uikit/src/v2'

import { UIKIT_COLORS } from '../../constants'
import RectLoader from '_components/rect-loader/index.jsx'
import { TIME_INTERVAL_VALUES } from '_components/interval-select/index.jsx'
import { useEventFeedsContext } from '../../../../../../pages/event-feeds/context'
import { TYPE_PREBUILT_ATTRIBUTES_V2 } from '../../../../../../pages/event-feeds/wizard'

import './styles.scss'

const TYPE_COLOR_MAPPING = {
  users: {
    primary: UIKIT_COLORS.ds_blue_dark,
    secondary: UIKIT_COLORS.ds_blue_lightest,
  },
  events: {
    primary: UIKIT_COLORS.ds_green,
    secondary: UIKIT_COLORS.ds_green_five,
  },
}

const AverageCounts = ({ count, interval, noIcon, loading, type = 'events' }) => {
  const { data: feedData } = useEventFeedsContext()
  const predictors = feedData.type === TYPE_PREBUILT_ATTRIBUTES_V2

  return (
    <div className="average-counts">
      <If condition={!noIcon}>
        <div
          style={{ backgroundColor: TYPE_COLOR_MAPPING[type].secondary }}
          className="average-counts__icon"
        >
          <Icon
            icon="analytics"
            width={16}
            height={16}
            backgroundColor={TYPE_COLOR_MAPPING[type].secondary}
            color={TYPE_COLOR_MAPPING[type].primary}
          />
        </div>
      </If>

      <h2 className="average-counts__title">
        <If condition={predictors}>Expected number of unique users with a score above 0</If>
        <If condition={!predictors}>
          Average {type.charAt(0).toUpperCase() + type.slice(1)} Per{' '}
          {interval === TIME_INTERVAL_VALUES.DAILY
            ? 'Day'
            : interval === TIME_INTERVAL_VALUES.WEEKLY
            ? 'Week'
            : interval === TIME_INTERVAL_VALUES.MONTHLY
            ? 'Month'
            : ''}
        </If>
      </h2>
      <p className="average-counts__count">
        <If condition={!loading && count}>{format('metric', count)}</If>
        <If condition={loading}>
          <RectLoader style={{ margin: '0 0' }} width={80} height={20} />
        </If>
      </p>
    </div>
  )
}

export default AverageCounts
